<h1 mat-dialog-title [attr.data-cy]="'uudud_h1_1_4_'">Untersuchungsgruppe {{ edit ? "bearbeiten" : "erstellen" }}</h1>
<div mat-dialog-content>
    <mat-form-field style="width: 100%" [attr.data-cy]="'uudud_mat-form-field_1_8_'">
        <input
            matInput
            type="text"
            placeholder="Untersuchungsgruppe"
            [formControl]="untersuchungsgruppeCtrl"
            [attr.data-cy]="'uudud_input_1_1_'"
        />
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="cancel()" [attr.data-cy]="'uudud_button_1_0_'">Abbrechen</button>
    <button
        mat-flat-button
        color="primary"
        (click)="save()"
        cdkFocusInitial
        [disabled]="untersuchungsgruppeCtrl.invalid"
        [attr.data-cy]="'uudud_button_2_0_'"
        >Speichern</button
    >
</div>
